<header *ngIf="loggedIn; else logInHeader">
  <div>
    <div class="menu-container mr-md-q light-gray" [ngClass]="{hidden: env.hideSomeUIElements}">
      <button
        (click)="isAppsMenuVisible = !isAppsMenuVisible"
        class="menu-button"
        data-test-id="button_navigation_menu"
        [ngClass]="{'light-gray': !isAppsMenuVisible, black: isAppsMenuVisible}"
      >
        <span class="icon icon-app-menu h3"></span>
      </button>
      <div *ngIf="isAppsMenuVisible" class="apps-drop-down-menu">
        <div class="drop-down-header">
          <span>Fusion apps</span>
        </div>
        <div>
          <ul class="fusion-apps-list">
            <li>OPS Desk</li>
            <li>CreateIt</li>
            <li>LaunchIt</li>
            <li>PlanIt</li>
            <li>ProduceIt</li>
            <li>PromoteIt</li>
            <li>MerchandiseIt</li>
            <li>ShipIt</li>
          </ul>
        </div>
      </div>
      <div *ngIf="isAppsMenuVisible" (click)="isAppsMenuVisible = false" class="overlay"></div>
    </div>
    <img src="../../../../assets/icons/incomm_logo.svg" class="incomm-logo mr-1h mr-md-h" alt="" />
    <div class="light-gray medium fs-xlg">{{ 'module.nav-header.appName' | translate }}</div>
    <nav class="nav-list ml-md-h">
      <mat-tab-group>
        <mat-tab *ngFor="let nav of navList">
          <ng-template [appUserPermissionsV2]="nav.permissions">
            <ng-template mat-tab-label>
              <a
                [routerLink]="nav.route"
                [ngClass]="{'d-none': (nav.value === 'dashboard' || nav.value === 'help') && env.hideSomeUIElements}"
                routerLinkActive="active"
                class="nav-link medium fs-xs"
                [attr.data-test-id]="'link_navigation_' + nav.route"
                href="javascript:void(0);"
              >
                {{ 'module.nav-header.nav-tab-' + nav.value | translate | uppercase }}
              </a>
            </ng-template>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </nav>
  </div>
  <div class="d-flex column fs-xs color-gray jc-center" [ngClass]="{'color-navi-no-dark': env.hideVersion}">
    <span>UI - {{ version?.ui }}</span>
    <span>API - {{ version?.api }}</span>
  </div>
  <div>
    <ng-container *appUserPermissionsV2="userRoles.APP.CREATE_REQUEST">
      <button
        *ngIf="loggedInProduceit && !isPoApprovals"
        class="button new-req-button mr-md-h py-md-h px-md-h relative"
        data-test-id="button_navigation_new_request"
        (click)="createNewRequest()"
      >
        <span>
          <span class="icon icon-add" [ngClass]="{'color-transparent': buttonLoader}"></span>
          <span [ngClass]="{'color-transparent': buttonLoader}">&nbsp;{{ 'common.button.create-request' | translate }}</span>
          <span class="spinner-container">
            <span *ngIf="buttonLoader" class="spinner spinner-white spinner-bounce-middle"></span>
          </span>
        </span>
      </button>
    </ng-container>
    <div class="notifications mr-md-h light-gray" [ngClass]="{hidden: env.hideSomeUIElements}">
      <span class="icon icon-notifications h3"></span>
    </div>
    <div
      class="user-profile-section px-md-1 light-gray d-flex ai-center"
      [matMenuTriggerFor]="userMenu"
      easyAria="Profile menu"
      data-test-id="nav_header_user_menu"
    >
      <div>
        <app-nav-profile-picture></app-nav-profile-picture>
      </div>
      <ng-template [appUserPermissions]="userRoles.APP.MIMIC_USER">
        <input
          class="ml-1 username-input"
          [ngClass]="{'changed-value': userName !== initialUserName}"
          [(ngModel)]="userName"
          (click)="$event.stopPropagation()"
          (keyup.enter)="refreshUserName()"
          [attr.data-test-id]="['nav_panel_header', 'mimic_input'].join('_')"
        />
        <button
          class="link icon icon-refresh"
          data-test-id="refresh_user_name"
          (click)="refreshUserName(); $event.stopPropagation()"
        ></button>
      </ng-template>
    </div>
    <mat-menu #userMenu="matMenu" xPosition="before">
      <div *ngIf="displayName" class="fs-sm user-panel-header" data-test-id="nav_header_title">
        {{ getUserInfo() }}
      </div>
      <p mat-menu-item data-test-id="dark_mode" [formGroup]="darkModeForm" click.stop-propagation>
        <mat-slide-toggle formControlName="enableDarkMode">{{ 'common.label.dark-mode' | translate }}</mat-slide-toggle>
      </p>
      <p mat-menu-item *ngIf="isMimicMode" (click)="resetMimic()">
        <span class="link p-0">{{ 'common.label.reset-mimic-user' | translate }}</span>
      </p>
      <p mat-menu-item (click)="substitute()" *ngIf="substituteEnabled" data-test-id="substitute_users">
        <span class="link p-0">{{ 'module.substitute.text.substitute-users' | translate }}</span>
      </p>
      <p mat-menu-item (click)="settings()" data-test-id="settings" *ngIf="settingsVisible$ | async">
        <span class="link p-0">{{ 'common.label.settings' | translate }}</span>
      </p>
      <p mat-menu-item (click)="logOut()">
        <span class="link p-0">{{ 'common.label.log-out' | translate }}</span>
      </p>
    </mat-menu>
  </div>
</header>
<div class="mimic-notification color-error d-flex jc-end sticky t-1">
  <p class="m-0 mt-h mr-h absolute mimic-notification-inner" [attr.data-test-id]="'mimic_mode_indication'">
    {{ 'common.label.mimic-mode' | translate }}
  </p>
</div>

<ng-template #logInHeader>
  <header>
    <div class="m-1">
      <img src="../../../../assets/icons/incomm_logo.svg" class="incomm-logo ml-md-h mr-md-h mr-1h" alt="" />
      <div class="light-gray medium fs-xlg">{{ 'module.nav-header.appName' | translate }}</div>
    </div>
    <div *ngIf="!allowAuthLogout; else authLogoutPanel" class="user-profile-section px-md-1 light-gray d-flex ai-center" (click)="logIn()">
      <app-nav-profile-picture></app-nav-profile-picture>
      <span class="link">Login</span>
    </div>
    <ng-template #authLogoutPanel>
      <div class="flex-1 jc-center">
        <span class="link" (click)="authLogOut()">Sign out</span>
        <span class="additional-details">and sign in again with a different Azure Active Directory user account.</span>
      </div>
    </ng-template>
  </header>
</ng-template>
